export enum ShipmentActionTypes {
    SET_SHIPMENTS = "SET_SHIPMENTS",
    CLEAR_USER_SHIPMENTS = "CLEAR_USER_SHIPMENTS",
    CLEAR_DEVICE_SHIPMENTS = "CLEAR_DEVICE_SHIPMENTS",
    CLEAR_ALL_SHIPMENTS = "CLEAR_ALL_SHIPMENTS"
}